<template>
  <div class="wizard-edit-page">
    <header class="wizard-edit-header">
      <div class="wizard-edit-titles">
        <h1>{{ title }}</h1>
        <p>{{ description }}</p>
      </div>
       <div class="wizard-edit-actions">
         <slot name="actions" />
         <ExecutorWizardBackButton />
       </div>
    </header>
    <div class="wizard-edit-body">
      <slot />
    </div>
  </div>
</template>

<script>
import ExecutorWizardBackButton from './ExecutorWizardBackButton.vue'

export default {
  name: 'ExecutorWizardEditLayout',
  components: { ExecutorWizardBackButton },
  props: {
    title: { type: String, required: true },
    description: { type: String, required: true },
  },
}
</script>

<style scoped>
.wizard-edit-page {
  background: #f5f7fb;
  display: flex;
  flex-direction: column;
  gap: 18px;
  min-height: calc(100vh - 70px);
  padding: 24px;
}

.wizard-edit-header {
  align-items: center;
  display: flex;
  gap: 16px;
  justify-content: space-between;
}

.wizard-edit-titles h1 {
  color: #1f2937;
  font-size: 28px;
  font-weight: 700;
  margin: 0 0 6px;
}

.wizard-edit-titles p {
  color: #6b7280;
  font-size: 14px;
  margin: 0;
}

.wizard-edit-actions {
  align-items: center;
  display: flex;
  gap: 8px;
}

.wizard-edit-body {
  display: flex;
  flex-direction: column;
  gap: 18px;
  width: 100%;
}

@media (max-width: 720px) {
  .wizard-edit-header {
    align-items: flex-start;
    flex-direction: column;
  }
}
</style>
